import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "~/stores/authStore";
import { KeyLocalStore } from "~/common/constants";
import { useQueryClient } from "@tanstack/react-query";

const GoogleCallback = () => {
  const navigate = useNavigate();
  const { setUserInfo } = useAuthStore();
  const { authenticate } = useAuthStore();
  const queryClient = useQueryClient();
  useEffect(() => {
    const params: any = new URLSearchParams(window.location.search);
    const allParams: any = Object.fromEntries(params.entries());
    const accessToken = allParams.accessToken;
    if (accessToken) {
      localStorage.setItem(KeyLocalStore.accessToken, accessToken);
      localStorage.setItem(KeyLocalStore.tenantId, allParams.tenantId);

      authenticate();
      setUserInfo(allParams);
      navigate("/");
    } else {
      console.error("Access token not found!");
    }
  }, [navigate, queryClient, authenticate]);

  return <p>Đang xử lý đăng nhập...</p>;
};

export default GoogleCallback;
